import React, { useState } from 'react'
import { Box, Typography, Grid, TextField, Button } from '@material-ui/core'

const ClientInfo = ({ lead, classes, filterStyles }) => {
  const [showAddress, setShowAddress] = useState(false)

  const toggleAddress = () => {
    setShowAddress(!showAddress)
  }

  return (
    <Box className={classes.box}>
      <Typography className={classes.cardSubTitles}>
        Informações do cliente:
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={4}>
          <TextField
            label="Nome"
            fullWidth
            disabled
            value={lead?.client?.name}
            key={`input-name-${lead?.client?.name}`}
          />
        </Grid>

        <Grid item xs>
          <Grid container spacing={4} alignItems="flex-end">
            <Grid item xs={5}>
              <TextField
                label="Email"
                fullWidth
                disabled
                value={lead?.client?.email}
                key={`input-email-${lead?.client?.email}`}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                label="Telefone"
                fullWidth
                disabled
                value={lead?.client?.phone}
                key={`input-phone-${lead?.client?.phone}`}
              />
            </Grid>

            <Grid item xs>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Button
                    type="button"
                    onClick={toggleAddress}
                    fullWidth
                    className={filterStyles.btnAdd}
                    style={{textTransform: 'none'}}
                  >
                    Ver Endereço
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {showAddress && (
          <Grid item xs={12}>
            <Grid container spacing={4}>
              <Grid item xs={3}>
                <TextField
                  label="Rua"
                  fullWidth
                  disabled
                  value={lead?.client?.street}
                  key={`input-street-${lead?.client?.street}`}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Bairro"
                  fullWidth
                  disabled
                  value={lead?.client?.neighborhood}
                  key={`input-neighborhood-${lead?.client?.neighborhood}`}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Cidade"
                  fullWidth
                  disabled
                  value={lead?.client?.city}
                  key={`input-city-${lead?.client?.city}`}
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  label="CPF/CNPJ"
                  fullWidth
                  disabled
                  value={lead?.client?.cpf_cnpj}
                  key={`input-cpf_cnpj-${lead?.client?.cpf_cnpj}`}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default ClientInfo
